import React, { useEffect } from 'react';
import { getProcessor } from '@starflow/app/helpers/flow';
import LabelEditer from '../../LabelEditer';
import FlowNodeIcon from '../../FlowNodeIcon';
import FlowNodeStatus from '../../FlowNodeStatus';
import { registerType } from '../../../../../constants';
import { translate } from '@shakkerai/util-i18n';

const Unit = React.memo(({ node: { data }, isSelected, sortNum }) => {
  const handleClick = () => {
    const processor = getProcessor(data.type);

    if (processor?.onNodeClick) {
      processor.onNodeClick(data);
    }
  };

  return (
    <div
      draggable
      data-type={registerType.UNIT}
      data-id={data.id}
      onClick={handleClick}
      data-num={sortNum}
      className={`relative min-w-[150px] px-[10px] flex items-center h-[34px] ml-[20px] border rounded cursor-pointer ${
        isSelected ? 'border-primary bg-[#F5FAFF]' : 'border-[#E8EEF2] '
      }`}
    >
      <FlowNodeIcon type="unit" isSelected={isSelected} />
      <LabelEditer data={data} type={registerType.UNIT} className="text-xs text-[#2d2d2d] ml-[8px]" />
      {isSelected && <FlowNodeStatus text={translate('flow_edit')} />}
    </div>
  );
});

export default Unit;
